import { createInertiaApp, type ResolvedComponent } from "@inertiajs/react";
import { createElement, type ReactNode } from "react";
import { createRoot } from "react-dom/client";
import AppShell from "../layout/AppShell";

type PageModule = {
  default: ResolvedComponent;
};

createInertiaApp({
  id: "app",
  // Set default page title
  // see https://inertia-rails.dev/guide/title-and-meta
  title: (title) => (title ? `${title} - ICT BLJ DocPortal` : "ICT BLJ DocPortal"),
  resolve: (name) => {
    const pages = import.meta.glob<PageModule>("../pages/**/*.tsx", {
      eager: true,
    });
    const page = pages[`../pages/${name}.tsx`];
    if (!page) {
      throw new Error(`Missing Inertia page component: '${name}.tsx'`);
    }

    // To use a default layout, import the Layout component
    // and use the following line.
    // see https://inertia-rails.dev/guide/pages#default-layouts
    //
    // page.default.layout ||= (page) => createElement(Layout, null, page)

    if (page.default.layout === undefined) {
      page.default.layout = (page: ReactNode) => AppShell({ children: page });
    }

    return page;
  },
  setup: ({ el, App, props }) => {
    if (el) {
      createRoot(el).render(createElement(App, props));
    } else {
      console.error("Missing root element.");
    }
  },
});
